<template>
  <ul class="nav nav-tabs">
    <li class="nav-item">
      <a
        :class="`nav-link ${tab === 'general_database' ? 'active' : ''}`"
        href="#"
        tabindex="0"
        @click="e => onTabSelected('tab', 'general_database')"
        >General Database</a
      >
    </li>
    <li class="nav-item">
      <a
        :class="`nav-link ${tab === 'selected_speakers' ? 'active' : ''}`"
        href="#"
        tabindex="1"
        @click="e => onTabSelected('tab', 'selected_speakers')"
        >Selected Speakers</a
      >
    </li>
    <li class="nav-item">
      <a
        :class="`nav-link ${tab === 'new_applicants' ? 'active' : ''}`"
        href="#"
        tabindex="2"
        @click="e => onTabSelected('tab', 'new_applicants')"
        >New Applicants</a
      >
    </li>
    <li class="nav-item">
      <a
        :class="`nav-link ${tab === 'removed' ? 'active' : ''}`"
        href="#"
        tabindex="3"
        @click="e => onTabSelected('tab', 'removed')"
        >Removed</a
      >
    </li>
    <li class="nav-item">
      <a
        :class="`nav-link ${tab === 'email_bounces' ? 'active' : ''}`"
        href="#"
        tabindex="4"
        @click="e => onTabSelected('tab', 'email_bounces')"
        >Email Bounces</a
      >
    </li>
    <li class="nav-item">
      <a
        :class="`nav-link ${tab === 'family_and_friends' ? 'active' : ''}`"
        href="#"
        tabindex="5"
        @click="e => onTabSelected('tab', 'family_and_friends')"
        >Family & Friends</a
      >
    </li>
    <li class="nav-item">
      <a
        :class="`nav-link ${tab === 'rejected' ? 'active' : ''}`"
        href="#"
        tabindex="5"
        @click="e => onTabSelected('tab', 'rejected')"
        >Rejected</a
      >
    </li>
    <li class="nav-item">
      <a
        :class="`nav-link ${tab === 'hire_vue' ? 'active' : ''}`"
        href="#"
        tabindex="5"
        @click="e => onTabSelected('tab', 'hire_vue')"
        >HireVue</a
      >
    </li>
    <li class="nav-item">
      <a
        :class="`nav-link ${tab === 'update_needed' ? 'active' : ''}`"
        href="#"
        tabindex="5"
        @click="e => onTabSelected('tab', 'update_needed')"
        >Update Needed</a
      >
    </li>
  </ul>
</template>

<script>
export default {
  name: "databaseSelector",
  props: {
    tab: {
      type: String,
      required: true,
      default: () => {
        return "general";
      }
    },
    onTabSelected: {
      type: Function,
      required: true,
      default: () => {}
    }
  }
};
</script>

<style></style>
